import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 7.5L12 4L20 7.5L12 11L4 7.5Z" fill="currentColor" />
    <path d="M4 11.5L12 15L20 11.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 15.5L12 19L20 15.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Header = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-50 bg-[#FDFCF8]/80 backdrop-blur-md border-b border-gray-100">
      <div className="container mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center text-black">
            <Logo size={36} />
            <span className="font-display text-2xl ml-3 tracking-tighter cursor-pointer" onClick={() => navigate('/')}>SORA</span>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-600">
          <a href="#sobre" className="hover:text-purple-600 transition-colors">Sobre</a>
          <a href="#planos" className="hover:text-purple-600 transition-colors">Planos</a>
          {/* <a href="#blog" className="hover:text-purple-600 transition-colors">Blog</a> */}
        </nav>

        <div className="flex items-center gap-4">
          <button
            onClick={handleLoginClick}
            className="hidden sm:block text-sm font-semibold text-gray-700 hover:text-purple-600"
          >
            Entrar
          </button>
          {/* <button className="bg-[#FFB800] hover:bg-[#E5A600] text-black font-display py-2.5 px-6 rounded-full transition-all text-sm shadow-sm hover:shadow-md active:scale-95">
            Participar da comunidade
          </button> */}
        </div>
      </div>
    </header>
  );
};

export default Header;

